import { render, staticRenderFns } from "./node-area-icon.vue?vue&type=template&id=789736da&scoped=true&"
import script from "./node-area-icon.vue?vue&type=script&lang=js&"
export * from "./node-area-icon.vue?vue&type=script&lang=js&"
import style0 from "./node-area-icon.vue?vue&type=style&index=0&id=789736da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789736da",
  null
  
)

export default component.exports